import { InjectionToken } from '@angular/core';

export const HOST = new InjectionToken<string>('host');
